import { OrderListResponseType } from "@sellar-io/api-v2/types";
import { capitalize } from "@sellar-io/common";
import { BadgeZinc } from "../../components/badge/Badge";

export const OrderInitiatorIndicator = ({
  initiator,
}: {
  initiator: OrderListResponseType[number]["initiator"];
}) => {
  if (!initiator) return null;

  return <BadgeZinc icon={"HANDSHAKE"}>{capitalize(initiator)}</BadgeZinc>;
};
